"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addStatesHandle;
function addStatesHandle() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  if (wapp.states) {
    wapp.states.addHandle({
      userToState: function userToState(req, res, next) {
        if (wapp.states.shouldInitializedStore) {
          var appStateName = res.wappResponse.appStateName;
          var initialState = window[appStateName];
          if (initialState) {
            var _initialState$req;
            req.wappRequest.user = ((_initialState$req = initialState.req) === null || _initialState$req === void 0 ? void 0 : _initialState$req.user) || null;
            req.user = req.wappRequest.user;
          }
        }
        next();
      }
    });
  }
}